export const LAYOUT_ROW_HEIGHT = 8;
export const LAYOUT_COLUMN_TOTAL = 12;

export const MODULE_ERROR_MESSAGE = `🔍 Oops, something went wrong loading this module. Our team has been alerted and we're working on a fix.`;

export enum ItemTypes {
  Module = 'module',
  ModuleDragHandle = 'module-drag-handle',
  LibraryComponent = 'library-component',
}

export enum DragHandleLocation {
  TopLeft,
  TopRight,
  BottomLeft,
  BottomRight,
}

export enum AlternativeModuleNames {
  ComponentLibrary = 'component-library',
  Tabs = 'tabs',
}

export enum ModuleTypes {
  Account = 'account',
  AccountInfo = 'account_info',
  AccountSimilaritySelfie = 'account_similarity_selfie',
  Button = 'button',
  CaseAttachments = 'case_attachments',
  CaseComments = 'case_comments',
  CaseEmail = 'case_email',
  CaseInfo = 'case_info',
  Checklist = 'checklist',
  DataDisplay = 'data_display',
  DataTable = 'data_table',
  Device = 'device',
  EventTimeline = 'event_timeline',
  Graph = 'graph',
  Graphv2 = 'graphv2',
  Iframe = 'iframe',
  Input = 'input',
  InputSelect = 'input_select',
  Inquiry = 'inquiry',
  Inquiryv2 = 'inquiryv2',
  KeyValue = 'key_value',
  ListMatches = 'list_matches',
  Location = 'location',
  Markdown = 'markdown',
  RelatedCases = 'related_cases',
  Relations = 'relations',
  Report = 'report',
  Reportv2 = 'reportv2',
  ReportRun = 'report_run',
  Resource = 'resource',
  Sar = 'sar',
  Table = 'table',
  Tags = 'tags',
  Transaction = 'transaction',
  FieldUpdate = 'field_update',
  Verification = 'verification',
  Verificationv2 = 'verificationv2',
  InsightsSummary = 'insights_summary',
  // the following modules may be used in a case layout, but are not creatable by users and must be manually configured
  LayoutByAccount = 'layout_by_account',
  AISummary = 'ai_summary',
}

export type AccountModuleTypes =
  | ModuleTypes.AccountInfo
  | ModuleTypes.DataDisplay
  | ModuleTypes.Relations
  | ModuleTypes.RelatedCases
  | ModuleTypes.Inquiryv2
  | ModuleTypes.Reportv2
  | ModuleTypes.Verificationv2
  | ModuleTypes.Markdown
  | ModuleTypes.Tags
  | ModuleTypes.Graphv2
  | ModuleTypes.EventTimeline
  | ModuleTypes.ListMatches;

export type TransactionModuleTypes =
  | ModuleTypes.DataDisplay
  | ModuleTypes.Relations
  | ModuleTypes.Inquiryv2
  | ModuleTypes.Reportv2
  | ModuleTypes.Verificationv2
  | ModuleTypes.Markdown
  | ModuleTypes.Tags
  | ModuleTypes.EventTimeline
  | ModuleTypes.ListMatches;

export const MODULE_TYPE_TO_NAME: Record<ModuleTypes, string> = {
  [ModuleTypes.Account]: 'Account',
  [ModuleTypes.AccountInfo]: 'Info',
  [ModuleTypes.AccountSimilaritySelfie]: 'Similarity Selfie',
  [ModuleTypes.Button]: 'Button',
  [ModuleTypes.CaseAttachments]: 'Attachments',
  [ModuleTypes.CaseComments]: 'Comments',
  [ModuleTypes.CaseEmail]: 'Email',
  [ModuleTypes.CaseInfo]: 'Info',
  [ModuleTypes.Checklist]: 'Checklist',
  [ModuleTypes.DataDisplay]: 'Data display',
  [ModuleTypes.Device]: 'Device',
  [ModuleTypes.EventTimeline]: 'Event timeline',
  [ModuleTypes.FieldUpdate]: 'Field Update',
  [ModuleTypes.Graph]: 'Graph',
  [ModuleTypes.Graphv2]: 'Graph',
  [ModuleTypes.Input]: 'Input',
  [ModuleTypes.InputSelect]: 'Select',
  [ModuleTypes.Inquiry]: 'Inquiry',
  [ModuleTypes.KeyValue]: 'Key value',
  [ModuleTypes.ListMatches]: 'List matches',
  [ModuleTypes.Location]: 'Location',
  [ModuleTypes.Markdown]: 'Markdown',
  [ModuleTypes.RelatedCases]: 'Related cases',
  [ModuleTypes.Relations]: 'Relations',
  [ModuleTypes.Report]: 'Report',
  [ModuleTypes.Reportv2]: 'Report',
  [ModuleTypes.ReportRun]: 'Report Run',
  [ModuleTypes.Resource]: 'Resource',
  [ModuleTypes.Table]: 'Table',
  [ModuleTypes.Tags]: 'Tags',
  [ModuleTypes.Transaction]: 'Transactions',
  [ModuleTypes.Sar]: 'SAR',
  [ModuleTypes.Verification]: 'Verification',
  [ModuleTypes.Verificationv2]: 'Verification',
  // the following modules are for internal use only
  [ModuleTypes.Iframe]: 'Iframe',
  [ModuleTypes.InsightsSummary]: 'Insights Summary',
  [ModuleTypes.LayoutByAccount]: 'Account grouping layout',
  [ModuleTypes.AISummary]: 'AI Summary',
  // TODO(Ernest): move this up once we release it
  [ModuleTypes.DataTable]: 'Data Table',
  // the following module are for account 2.0 only (with layout variables)
  [ModuleTypes.Inquiryv2]: 'Inquiry',
};
